module.exports = __webpack_public_path__ + "img/bg-profile.3a4b5e27.svg";